import { TableCustomCell } from "src/app/modules/component/table/components/TableCustomCell";
import CellFormatter from "../../../component/cell-formatter";
import {DATA_TYPE_XN} from "../../../phan-he-xet-nghiem/const/constants";

const columnsDSKhamBenh = [
  {
    title: "Tên dịch vụ",
    field: "name",
    className: "spaces width-40",
    render: (rowData: any) => {
      return <TableCustomCell data={rowData?.termName} />;
    },
  },
  {
    title: "SL",
    field: "soLuong",
    className: "spaces width-3 text-center",
    render: (rowData: any) => {
      const DEFAULT_QUANTITY = 1;
      return (
        <TableCustomCell data={rowData?.soLuong || DEFAULT_QUANTITY} />
      );
    },
  },
  {
    title: "Loại công khám",
    field: "type",
    className: "spaces width-11",
    render: (rowData: any) => {
      return (
        <TableCustomCell data={rowData?.type} />
      );
    },
  },
  {
    title: "Ghi chú",
    field: "ghiChu",
    className: "spaces width-14",
    render: (rowData: any) => {
      return (
        <TableCustomCell data={rowData?.ghiChu} />
      )
    },
  }
];

export { columnsDSKhamBenh };
